<terra-welcome-layout [showReleaseNotification]="false">
  <ng-container *ngIf="{logoData: referrerLogo$ | async} as referrer">
    <img class="referrer-logo" *ngIf="referrer?.logoData?.showLogo" [src]="referrer?.logoData?.logoUrl"/>
  </ng-container>

  <section class="welcome-text">Hi there!</section>

  <section class="welcome-sub-text" *ngIf="!isLoading">
    @if (!isGp) {
      <p>{{gpCompanyName}} shared an investment <br/> agreement for {{assetName}} with you</p>
    } @else {
      <p>Investor has signed the agreement. Now it's your turn</p>
    }
  </section>

  <section class="form-content">
    @if (isLoading) {
      <terra-loader [centerToParent]="true" />
    }

    <h1 class="mt-4">
      Review and sign the agreement
    </h1>

    @if (!isLoading) {
      <button type="submit" mat-flat-button class="tall-button" color="primary" [disabled]="isLoading || agreementSigned" (click)="openSignUrl();">
        Review & Sign Agreement
      </button>
    }
  </section>
</terra-welcome-layout>
